import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-gray-900 py-16 md:py-20 text-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
          {/* Company Info */}
          <div>
            <div className="text-white mb-6">
              <h3 className="text-4xl font-bold">Keziah</h3>
              <p className="text-lg">Global Private Limited</p>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Keziah Global Private Limited<br />
              First Floor, GR Complex,<br />
              20 Ramakrishna Road,<br />
              Salem - 636007, Tamil Nadu, India
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-6 text-lg md:text-xl text-white">
              Quick Links
            </h4>
            <ul className="space-y-4 md:space-y-5">
              <li>
                <Link
                  to="/about-us"
                  className="hover:text-blue-400 text-gray-300 text-base md:text-lg transition duration-300"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-blue-400 text-gray-300 text-base md:text-lg transition duration-300"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="hover:text-blue-400 text-gray-300 text-base md:text-lg transition duration-300"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-blue-400 text-gray-300 text-base md:text-lg transition duration-300"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h4 className="font-bold mb-6 text-lg md:text-xl text-white">
              Contact Us
            </h4>
            <ul className="space-y-4 md:space-y-5">
              <li>
                <div className="flex items-center text-gray-300 text-base md:text-lg">
                  <FaPhoneAlt className="mr-3 text-blue-400" />
                  <a
                    href="tel:9043588446"
                    className="hover:text-blue-400 transition duration-300"
                  >
                    +91 90435 88446
                  </a>
                </div>
              </li>
              <li>
                <div className="flex items-center text-gray-300 text-base md:text-lg">
                  <FaEnvelope className="mr-3 text-blue-400" />
                  <a
                    href="mailto:support@kpltd.in"
                    className="hover:text-blue-400 transition duration-300"
                  >
                    support@kpltd.in
                  </a>
                </div>
              </li>
              <li>
                <div className="flex items-start text-gray-300 text-base md:text-lg">
                  <FaMapMarkerAlt className="mr-3 text-blue-400 mt-1" />
                  <p>
                    First Floor, GR Complex, <br /> 20 Ramakrishna Road, Salem
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright and Credits */}
        <div className="mt-12 md:mt-16 border-t border-gray-700 pt-8 md:pt-10 text-center">
          <p className="text-gray-400 text-sm md:text-base">
            &copy; {new Date().getFullYear()} Keziah Global Private Limited. All rights
            reserved.
          </p>
          <p className="mt-3 text-gray-400 text-sm md:text-base">
            Crafted with <span className="text-red-500">❤️</span> at{" "}
            <a
              href="https://zasii.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline"
            >
              Zasii Technologies
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;